//@flow
import React from 'react';
import LazyLoad from 'react-lazyload';
import Link from '../../../components/Link';
import imgPlaceholder from '../../../images/catalog/placeholder-product-image.jpg';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type ProductModel from '../../Stores/Products/productModel';
import type StockCollection from '../../Stores/Stock/stockCollection';

function _renderProductPhoto(product:ProductModel) {
  return (
    <Link to={product.getOfficeUrl()} external={true} className="photo">
      <LazyLoad
        offset={500}
        placeholder={<img src={imgPlaceholder} className="snack-image-placeholder" alt={product.getName()} />}
      >
        <img
          className="snack-image"
          src={product.getSnackcardImageUrl(300,235)}
          alt={product.getName()}
        />
      </LazyLoad>
    </Link>
  );
}

function _renderProduct(product:ProductModel) {
  return (
    <li className="grid-item snack-card" key={product.getSku()}>
      <div className="photo-container">
        {_renderProductPhoto(product)}
        {product.getComingSoon() && (
          <div className="coming-soon-container">
            <p>Coming soon</p>
          </div>
        )}
      </div>
      <div className="snack-name-container">
        <div className="snack-name">
          <h1>{product.getDisplayName() || product.getName()}</h1>
        </div>
      </div>
    </li>
  );
}

function _renderNoProducts() {
  const text = "All of these items have sold out and will be back in stock soon!";
  return (
    <div>{text}</div>
  );
}

type Props = {
  title?:string,
  category?:CategoryModel,
  skus?:string[],
  products:ProductsCollection,
  stock:StockCollection,
  filterByStock:boolean,
};

export default function OfficeCategory(props:Props):React$Node {
  const skus = props.skus
    ? props.skus
    : props.category ? props.category.getProductsSkus() : [];
  let products = props.products.getProductsBySkus(skus);
  products = props.filterByStock ? products.filter(
    prod => props.stock.inStock(prod.getSku()) ) : products;

  const title = props.title
    ? props.title
    : props.category ? props.category.getName() : '';
  return (
    <div className="office-category">
      {title && <h2>{title}</h2>}
      <ul className="office-category-grid">
        {products.length > 0
          ? products.map(product => _renderProduct(product))
          : _renderNoProducts()
        }
      </ul>
    </div>
  );
}
